import {
  AttackErrorAttribute,
  AttackPointAttribute,
  BlockPointAttribute,
  ChallengeAttribute,
  DigAttribute,
  NeutralAttackAttribute,
  ReceptionAttribute,
  TechnicalErrorAttribute,
  VolleyballCardsAttribute,
  VolleyballIncidentId,
  VolleyballRefereeChallengeAttribute,
} from '@collector/sportsapi-client-legacy'

import { HistoryIncidentsConfig } from '../../configuration'

export const historyIncidentsConfig: HistoryIncidentsConfig<VolleyballIncidentId> =
  {
    [VolleyballIncidentId.RefereeChallenge]: {
      singleAttributes: true,
      attributeIds: [
        VolleyballRefereeChallengeAttribute.CallStands,
        VolleyballRefereeChallengeAttribute.CallOverturned,
      ],
    },
    [VolleyballIncidentId.Point]: {
      participant: {
        name: 'scorer',
        required: true,
      },
    },
    [VolleyballIncidentId.AttackPoint]: {
      participant: {
        name: 'attacker',
        required: true,
      },
      singleAttributes: true,
      attributeIds: [
        AttackPointAttribute.Zone1,
        AttackPointAttribute.Zone2,
        AttackPointAttribute.Zone3,
        AttackPointAttribute.Zone4,
        AttackPointAttribute.Zone5,
        AttackPointAttribute.Zone6,
      ],
    },
    [VolleyballIncidentId.BlockPoint]: {
      participant: {
        name: 'blocker',
        required: true,
      },
      assistant: {
        name: 'attacker',
        shouldLoadOppositeSubParticipants: true,
      },
      singleAttributes: true,
      attributeIds: [
        BlockPointAttribute.Zone1,
        BlockPointAttribute.Zone2,
        BlockPointAttribute.Zone3,
        BlockPointAttribute.Zone4,
        BlockPointAttribute.Zone5,
        BlockPointAttribute.Zone6,
      ],
    },
    [VolleyballIncidentId.ServiceAce]: {
      participant: {
        name: 'server',
        required: true,
      },
      assistant: {
        name: 'receiver',
        shouldLoadOppositeSubParticipants: true,
      },
    },
    [VolleyballIncidentId.AttackError]: {
      participant: {
        name: 'attacker',
        required: true,
      },
      attributeIds: [
        AttackErrorAttribute.OutAttack,
        AttackErrorAttribute.AntennaAttack,
        AttackErrorAttribute.NetAttack,
        AttackErrorAttribute.IllegalTouch,
        AttackErrorAttribute.Zone1,
        AttackErrorAttribute.Zone2,
        AttackErrorAttribute.Zone3,
        AttackErrorAttribute.Zone4,
        AttackErrorAttribute.Zone5,
        AttackErrorAttribute.Zone6,
      ],
    },
    [VolleyballIncidentId.NeutralAttack]: {
      participant: {
        name: 'attacker',
      },
      attributeIds: [
        NeutralAttackAttribute.BlockedBack,
        NeutralAttackAttribute.Zone1,
        NeutralAttackAttribute.Zone2,
        NeutralAttackAttribute.Zone3,
        NeutralAttackAttribute.Zone4,
        NeutralAttackAttribute.Zone5,
        NeutralAttackAttribute.Zone6,
      ],
    },
    [VolleyballIncidentId.Serve]: {
      participant: {
        name: 'server',
        required: true,
      },
    },
    [VolleyballIncidentId.ServiceError]: {
      participant: {
        name: 'server',
        required: true,
      },
    },
    [VolleyballIncidentId.TechnicalErrors]: {
      participant: {
        name: 'player',
        required: true,
      },
      singleAttributes: true,
      attributeIds: [
        TechnicalErrorAttribute.RotationError,
        TechnicalErrorAttribute.FootFault,
        TechnicalErrorAttribute.NetTouch,
        TechnicalErrorAttribute.IllegalTouch,
      ],
    },
    [VolleyballIncidentId.Challenge]: {
      singleAttributes: true,
      attributeIds: [ChallengeAttribute.Correct, ChallengeAttribute.Incorrect],
    },
    [VolleyballIncidentId.Cards]: {
      participant: {
        name: 'player',
        required: true,
      },
      attributeIds: [
        VolleyballCardsAttribute.YellowCard,
        VolleyballCardsAttribute.RedCard,
        VolleyballCardsAttribute.PlayerExpulsion,
        VolleyballCardsAttribute.PlayerDisqualification,
      ],
    },
    [VolleyballIncidentId.Reception]: {
      participant: {
        name: 'receiver',
      },
      singleAttributes: true,
      attributeIds: [
        ReceptionAttribute.Perfect,
        ReceptionAttribute.Plus,
        ReceptionAttribute.Negative,
      ],
    },
    [VolleyballIncidentId.Dig]: {
      participant: {
        name: 'defender',
      },
      attributeIds: [DigAttribute.Spectacular, DigAttribute.FreeBall],
    },
    [VolleyballIncidentId.Set]: {
      participant: {
        name: 'setter',
      },
    },
  }
